/* eslint-disable no-return-assign */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect } from "react";
import { Card, CardBody, CardHeader, Button, Form, UncontrolledTooltip, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import { Plus, FilePlus, Trash2, Download, Paperclip, Info, ChevronRight, ChevronLeft, Edit, X } from "react-feather";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileCircleCheck, faUsers } from "@fortawesome/free-solid-svg-icons";
import useFetcher from "../../hooks/useFetcher";
import { BlurSpinner } from "../BlurSpinner";
import EditCandidatoFormModal from "./editCandidato/editCandidatoNpModal";
import NewCandidatoFormModal from "./newCandidato/newCandidatoNpModal";
import {
  getCandidatosByNP,
  patchCandidatoNp,
  postCandidatoNP,
  getCandidatosByDerivacion,
  uploadCandidatos,
  multiPatchCandidatosNp,
  postMarkAsReadedCandidato,
} from "../../services/candidatosNPServices";
import { getNotasDePedidoCategory } from "../../services/notasDePedidoServices";
import DeleteCandidatoModal from "./deleteCandidatoModal";
import { patchFile, uploadFiles } from "../../services/fileServices";
import { handleClickFile } from "../RelevosInfoGeneral/utils";
import ObservacionesModal from "./observacionesModal";
import { postDerivacion } from "../../services/derivacionServices";
import { handleErrors } from "../../services/handleErrors";
import MultiEditCandidatoFormModal from "./multiSetCandidatos/multiEditCandidatoNpModal";
import { formatObject, getEstadoByValue, getMotivoNoAvanza } from "./utils";
import ExistingCandidateModal from "./existingCandidatoModal";
import { InputCheckboxContainer } from "../../ui/inputs";
import { ContentKpi, IconKpi, KPIcard } from "../../ui/kpis";
import { tableCustomStylesNP } from "../../ui/table";
import { ButtonPrimary, ButtonSecondary, OptionsExportButton } from "../../ui/buttons";
import NuevaDerivacionFormModal from "../DerivacionesNp/createDerivacion/nuevaDerivacionModal";
import EditDerivacionFormModal from "../DerivacionesNp/editDerivacion/editDerivacionModal";
import { CircleButton } from "../../pages/NotasDePedidoDetail/styles";
import { NavWrapper, ArrowButton, SimulatedSlash } from "./styles";
import ConfirmModal from "../ConfirmModal";

export const uploadOrPatchFilesCV = async (id, files, fileId) => {
  if (fileId && fileId !== undefined) {
    await patchFile({ entity: "candidatosNP", entityId: id, fileId, files });
  } else {
    await uploadFiles({ entity: "candidatosNP", entityId: id, files });
  }
};

const CandidatosNP = ({
  nota,
  derivacionesData = [],
  coberturaState,
  vacantes,
  anularCancelar,
  handleIngresoCandidato,
  notaDePedidoId,
  handleNotaSave,
  reloadCandidatos,
  setReloadCandidatos,
  setReloadDerivaciones,
  handleEditDerivacion,
  estadoNP,
  deleteCandidatoDerivado,
  handleCreateDerivacion,
  derivacionId,
  setDerivacionId,
  editDerivacionForm,
  setEditDerivacionForm,
  setCoberturaState,
  canCreateOV,
}) => {
  const [candidatos, isLoadingCandidatos, , setCandidatos, fetchCandidatos] = useFetcher(getCandidatosByNP, [notaDePedidoId]);
  const [candidatosDerivados, isLoadingCandidatosDerivados, , , fetchCandidatosDerivados] = useFetcher(getCandidatosByDerivacion, [derivacionId, notaDePedidoId || ""]);
  const [categories, isLoadingCategoies] = useFetcher(getNotasDePedidoCategory, undefined);
  const motivos = categories && categories.estadoCandidatoNP && categories.estadoCandidatoNP.motivos;
  const [editCandidatoInfo, setEditCandidatoInfo] = useState({});
  const [nuevoCandidatoForm, setNuevoCandidatoForm] = useState(false);
  const [editCandidatoForm, setEditCandidatoForm] = useState(false);
  const [reclutando, setReclutando] = useState(null);
  const [deleteCandidato, setDeleteCandidato] = useState(false);
  const [showObservaciones, setShowObservaciones] = useState(false);
  const [observaciones, setObservaciones] = useState("");
  const [showMultiEditCandidato, setShowMultiEditCandidato] = useState(false);
  const [showActiveNotaModal, setShowActiveNotaModal] = useState(false);

  const [allCandidatosDerivados, setAllCandidatosDerivados] = useState([]);
  const [allCandidatosDerivadosIds, setAllCandidatosDerivadosIds] = useState([]);

  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);

  const [showExistingcandidate, setShowExistingcandidate] = useState(false);
  const [existingCandidateInfo, setExistingCandidateInfo] = useState({});
  const [uploadingCandidatos, setUploadingCandidatos] = useState(false);

  // -----------------------------------------------------------------------------
  const [nuevaDerivacionForm, setNuevaDerivacionForm] = useState(false);
  const servicioNotaDePedido = nota && nota.servicio;

  useEffect(() => {
    if (derivacionesData) {
      const cubiertas = derivacionesData.reduce((total, item) => {
        return total + item.cubiertas;
      }, 0);
      setCoberturaState(cubiertas);
    }
  }, [derivacionesData]);

  const derivacionesIds = derivacionesData ? derivacionesData.map((item) => item.id) : "";

  // -----------------------------------------------------------------------------
  // Se arma el array con los ids de candidatos que fueron derivados en esta NP
  useEffect(async () => {
    if (derivacionesIds && derivacionesIds.length > 0) {
      const derivados = derivacionesIds
        ? await Promise.all(
            derivacionesIds.map(async (id) => {
              const res = await getCandidatosByDerivacion(id, nota.id);
              const allCandidates = await res.result;

              return allCandidates;
            })
          )
        : [];

      setAllCandidatosDerivados(derivados);
    }
  }, [nota.id, nota, derivacionesData]);

  useEffect(() => {
    if (allCandidatosDerivados && allCandidatosDerivados.length > 0) {
      let list = [];
      allCandidatosDerivados.forEach((item) => {
        // se verifica q el item existe ya que esxiste la posibilidad de derivar candidatos sin detalle
        if (item) {
          const ids = item.map((i) => i.candidatoId);
          list = list.concat(ids);
        }
      });
      setAllCandidatosDerivadosIds(list);
    }
  }, [allCandidatosDerivados]);

  // -----------------------------------------------------------------------------

  const [activeTab, setActiveTab] = useState(derivacionId || "1");
  const [firstVisibleIndex, setFirstVisibleIndex] = useState(0);
  const maxVisibleTabs = 4;

  const handlePrevClick = () => {
    if (firstVisibleIndex > 0) {
      setFirstVisibleIndex(firstVisibleIndex - 1);
    }
  };

  const handleNextClick = () => {
    if (firstVisibleIndex + maxVisibleTabs < (derivacionesData && derivacionesData.length)) {
      setFirstVisibleIndex(firstVisibleIndex + 1);
    }
  };

  const visibleTabs = derivacionesData && derivacionesData.length > 0 && derivacionesData.slice(firstVisibleIndex, firstVisibleIndex + maxVisibleTabs);
  const derivacionSelected = derivacionesData && derivacionesData.length > 0 && derivacionesData.find((d) => d.id === derivacionId);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
    if (tab === derivacionId) {
      setDerivacionId(null);
      setActiveTab("1");
    } else {
      setDerivacionId(tab);
    }
  };

  const totalCandidatos = derivacionId ? (candidatosDerivados && candidatosDerivados.length) || 0 : candidatos && candidatos.length;
  const currentCandidatosList = derivacionId ? candidatosDerivados || [] : candidatos;

  const candidatosSinLeer =
    currentCandidatosList && currentCandidatosList.filter((candidato) => !candidato.lecturasCandidato[0] || !candidato.lecturasCandidato[0].readed).length;

  const handleEditCandidatoNpForm = (row) => {
    if (anularCancelar) return;
    setEditCandidatoForm(true);
    setEditCandidatoInfo(row);
  };
  const handleDeleteCandidatoModal = (row) => {
    setDeleteCandidato(true);
    setEditCandidatoInfo(row);
  };

  useEffect(() => {
    if (estadoNP === 1 && !reclutando && candidatos && candidatos.length > 5) {
      setReclutando(true);
      handleNotaSave({ estado: 2, fechaDeReclutando: moment().format("YYYY-MM-DD") });
    }
  }, [candidatos]);

  useEffect(() => {
    if (reloadCandidatos) {
      fetchCandidatos();
      fetchCandidatosDerivados();
      setReloadCandidatos(false);

      if (nota && nota.servicio === 1) handleNotaSave();
    }
  }, [reloadCandidatos]);

  const handleDownloadCV = async (row) => {
    toast.warn("Descargando CV...");

    await handleClickFile(row.Files[0]);
  };

  const handleCreateCandidato = async (candidatoData, files) => {
    const { servicio } = candidatoData;

    try {
      const { message, result, repetidos } = await postCandidatoNP(candidatoData);
      if (repetidos) {
        toast.warn(message);
        setExistingCandidateInfo(result);
        setShowExistingcandidate(true);
      } else {
        // se crea una derivacion junto con el candidato creado
        if (servicio === 1 && estadoNP !== 10 && estadoNP !== 12) {
          const derivacionData = {
            candidatos: 1,
            cubiertas: 0,
            candidatosDetalle: [{ id: result.id }],
            fechaDerivacion: moment().format("YYYY-MM-DD"),
            notaDePedidoId,
          };
          try {
            await postDerivacion(derivacionData);
            if (nota && nota.estado !== 10 && nota.estado !== 12) {
              await handleNotaSave({ estado: 3 });
            }
            setReloadDerivaciones(true);
          } catch (error) {
            handleErrors(error, toast.error);
          }
        }
        if (files) await uploadOrPatchFilesCV(result.id, files);
        toast.success(message);
        // ver cuando se asocia a derivacion
        const currentCandidatos = candidatos ? candidatos.length + 1 : 0;
        handleEditDerivacion({ notaDePedidoId: derivacionId, candidatos: currentCandidatos });
        fetchCandidatos();
      }
      return true;
    } catch (error) {
      toast.error(error.message);
      return false;
    }
  };

  const handleEditCandidatoNp = async (editData, files, fileId) => {
    const { message, result } = await patchCandidatoNp(editData.id, editData);
    if (files) await uploadOrPatchFilesCV(result.id, files, fileId);
    toast.success(message);
    if (editData.changeEstado) {
      // si cambia de estado a pre-ingreso (4) y la NP es derivada (3),
      // se cambia el estado general de la NP a pre-ingreso
      if (editData.changeEstado && editData.estado === 4 && estadoNP === 3) {
        handleNotaSave({ estado: 8 });
      }
    }
    setCandidatos(
      candidatos.map((objeto) => {
        if (objeto.id === result.id) {
          return { ...objeto, ...result };
        }
        return objeto;
      })
    );
    if (editData.derivacionId) {
      fetchCandidatosDerivados();
    }
    setReloadCandidatos(true);
    setEditCandidatoForm(false);
    handleIngresoCandidato();
  };

  const handleMultiEditCandidatos = async (editData) => {
    const dataToMultiEdit = formatObject(editData);
    const { message } = await multiPatchCandidatosNp(dataToMultiEdit);
    toast.success(message);

    // si cambia de estado a pre-ingreso (4) y la NP es derivada (3),
    // se cambia el estado general de la NP a pre-ingreso
    if (editData.changeEstado && editData.estado === 4 && estadoNP === 3) {
      handleNotaSave({ estado: 8 });
    }

    if (editData.derivacionId) {
      fetchCandidatosDerivados();
    }
    setReloadCandidatos(true);
    handleIngresoCandidato();

    setToggleCleared(!toggleCleared);
  };

  const handleUploadFileButton = () => {
    document.getElementById("upExcel").click();
  };
  const handleAddCandidatosFromExcel = async (e) => {
    setUploadingCandidatos(true);
    const selectedFiles = e.target.files;
    try {
      const response = await uploadCandidatos({ notaDePedidoId, files: selectedFiles });
      if (response.repetidos) {
        toast.warn(response.message);
        setExistingCandidateInfo(response.result);
        setShowExistingcandidate(true);
      } else if (response.error) {
        toast.error(response.message || response.error.message);
      } else {
        toast.success(response.message);
      }
    } catch (error) {
      handleErrors(error, toast.error);
    }

    setReloadCandidatos(true);
    setReloadDerivaciones(true);
    e.target.value = null;
    setUploadingCandidatos(false);
  };

  const handleMarkAsRead = async (e, row) => {
    const relsCandidatoNPId = row.id;
    const data = { relsCandidatoNPId, readed: e.target.checked };
    const { message } = await postMarkAsReadedCandidato(data);
    toast.success(message);
    setReloadCandidatos(true);
  };

  const handleRowSelected = React.useCallback((state) => {
    setSelectedRows(state.selectedRows);
  }, []);

  const contextComponent = React.useMemo(() => {
    const totalSelected = selectedRows.length;
    return (
      <div className="w-100 d-flex justify-content-between">
        <OptionsExportButton className="border" onClick={() => setToggleCleared(!toggleCleared)}>
          <div className="d-flex align-items-center">
            <p className="my-0 mr-2 bold" style={{ fontFamily: "Nunito", fontSize: "16px" }}>
              {totalSelected > 1 ? `${totalSelected} candidatos seleccionados` : `${totalSelected} candidato seleccionado`}
            </p>
            <X size={16} />
          </div>
        </OptionsExportButton>
        <ButtonPrimary key="cambiar-estado" onClick={() => setShowMultiEditCandidato(!showMultiEditCandidato)} style={{ backgroundColor: "red" }} icon>
          Cambiar estado
        </ButtonPrimary>
      </div>
    );
  }, [selectedRows]);

  return (
    <>
      <BlurSpinner isLoading={isLoadingCandidatos || isLoadingCandidatosDerivados || isLoadingCategoies || uploadingCandidatos}>
        {showActiveNotaModal && (
          <ConfirmModal
            toggle={() => setShowActiveNotaModal(!showActiveNotaModal)}
            isOpen={showActiveNotaModal}
            title="¿Estas seguro de activar esta nota de pedido?"
            handleCancelar={() => {
              setShowActiveNotaModal(!showActiveNotaModal);
            }}
            handleContinuar={() => {
              setNuevaDerivacionForm(!nuevaDerivacionForm);
              setShowActiveNotaModal(!showActiveNotaModal);
            }}
          />
        )}
        {showExistingcandidate && (
          <ExistingCandidateModal
            isOpen={showExistingcandidate}
            toggle={() => setShowExistingcandidate(!showExistingcandidate)}
            info={existingCandidateInfo}
            notaDePedidoId={notaDePedidoId}
            derivacionId={derivacionId}
            setReloadCandidatos={setReloadCandidatos}
            setReloadDerivaciones={setReloadDerivaciones}
          />
        )}
        {showMultiEditCandidato && (
          <MultiEditCandidatoFormModal
            info={selectedRows}
            isOpen={showMultiEditCandidato}
            toggle={() => setShowMultiEditCandidato(!showMultiEditCandidato)}
            handleMultiEditCandidatos={handleMultiEditCandidatos}
            derivacionId={derivacionId}
            notaDePedidoId={notaDePedidoId}
            canCreateOV={canCreateOV}
          />
        )}
        {nuevoCandidatoForm && (
          <NewCandidatoFormModal
            isOpen={nuevoCandidatoForm}
            toggle={() => setNuevoCandidatoForm(!nuevoCandidatoForm)}
            notaDePedidoId={notaDePedidoId}
            derivacionId={derivacionId}
            handleCreateCandidato={handleCreateCandidato}
          />
        )}
        {editCandidatoForm && (
          <EditCandidatoFormModal
            canCreateOV={canCreateOV}
            info={editCandidatoInfo}
            isOpen={editCandidatoForm}
            toggle={() => {
              setEditCandidatoForm(!editCandidatoForm);
              setReloadCandidatos(true);
            }}
            handleEditCandidatoNp={handleEditCandidatoNp}
            notaDePedidoId={notaDePedidoId}
            derivacionId={derivacionId}
            cobertura={coberturaState}
            vacantes={vacantes}
            nota={nota}
          />
        )}
        {deleteCandidato && (
          <DeleteCandidatoModal
            isOpen={deleteCandidato}
            toggle={() => setDeleteCandidato(!deleteCandidato)}
            info={editCandidatoInfo}
            derivacionId={derivacionId}
            setReloadCandidatos={setReloadCandidatos}
            deleteCandidatoDerivado={deleteCandidatoDerivado}
          />
        )}
        {/* --------------------------------------------------------- Derivacion */}
        {nuevaDerivacionForm && (
          <NuevaDerivacionFormModal
            id={notaDePedidoId}
            isOpen={nuevaDerivacionForm}
            toggle={() => setNuevaDerivacionForm(!nuevaDerivacionForm)}
            uploadOrPatchFilesCV={uploadOrPatchFilesCV}
            handleCreateDerivacion={handleCreateDerivacion}
            vacantes={nota.vacantes}
            cobertura={coberturaState}
            fechaAbierta={nota.fechaAbierta}
            setReloadCandidatos={setReloadCandidatos}
            idsCandidatosDerivados={allCandidatosDerivadosIds}
            servicio={servicioNotaDePedido}
            candidatosDesdeMultiSelect={selectedRows}
          />
        )}
        {editDerivacionForm && (
          <EditDerivacionFormModal
            info={derivacionSelected}
            uploadOrPatchFilesCV={uploadOrPatchFilesCV}
            isOpen={editDerivacionForm}
            toggle={() => setEditDerivacionForm(!editDerivacionForm)}
            handleEditDerivacion={handleEditDerivacion}
            vacantes={nota.vacantes}
            cobertura={coberturaState}
            notaDePedidoId={notaDePedidoId}
            setReloadCandidatos={setReloadCandidatos}
            fechaAbierta={nota.fechaAbierta}
            idsCandidatosDerivados={allCandidatosDerivadosIds}
            servicio={servicioNotaDePedido}
            candidatosEnLaDerivacion={candidatosDerivados}
          />
        )}
        {/* --------------------------------------------------------- */}
        <Form className="p-absolute" style={{ height: "0px", width: "0px", overflow: "hidden" }}>
          <input id="upExcel" type="file" onChange={handleAddCandidatosFromExcel} multiple accept=".xls, .xlsx" />
        </Form>

        <Card className="mb-0 pt-0  w-100">
          <CardBody className="pb-3 mt-0 pt-0 sixth-step" style={{ overflow: "auto" }}>
            <NavWrapper className="fifth-step">
              <ArrowButton onClick={handlePrevClick} disabled={firstVisibleIndex === 0}>
                <ChevronLeft color="#f0292a" />
              </ArrowButton>
              <Nav tabs>
                {derivacionesData && derivacionesData.length > 0 ? (
                  visibleTabs.map((derivacion) => (
                    <NavItem key={derivacion.id}>
                      <NavLink
                        className={classnames({ active: activeTab === derivacion.id })}
                        onClick={() => {
                          toggleTab(derivacion.id);
                        }}
                      >
                        <>
                          <FontAwesomeIcon icon="fa-regular fa-calendar" className="mr-2" />
                          {derivacion && derivacion.fechaDerivacion
                            ? moment(derivacion.fechaDerivacion).format("DD/MM/YYYY")
                            : moment(derivacion.createdAt).format("DD/MM/YYYY")}
                          {derivacionId === derivacion.id && (
                            <>
                              <Button
                                style={{ zIndex: 10 }}
                                size="xs"
                                color="link"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setEditDerivacionForm(!editDerivacionForm);
                                }}
                              >
                                <Edit size="14" className="ml-2" color="#293134" />
                              </Button>
                            </>
                          )}
                        </>
                      </NavLink>
                    </NavItem>
                  ))
                ) : (
                  <NavItem>
                    <NavLink
                      className={classnames({ active: activeTab === 1 })}
                      onClick={() => {
                        toggleTab(0);
                      }}
                      style={{ position: "relative", display: "inline-block" }} // Asegura que el icono y el slash se posicionen correctamente
                    >
                      <FontAwesomeIcon icon="fa-regular fa-calendar" color="#f0292a" />
                      <SimulatedSlash />
                    </NavLink>
                  </NavItem>
                )}
              </Nav>
              <ArrowButton onClick={handleNextClick} disabled={firstVisibleIndex + maxVisibleTabs >= derivacionesData.length}>
                <ChevronRight color="#f0292a" />
              </ArrowButton>
              <UncontrolledTooltip target="New-Derivation">Crear nueva derivación</UncontrolledTooltip>
              <CircleButton
                id="New-Derivation"
                type="button"
                onClick={() => {
                  if (nota.estado === 12) {
                    setShowActiveNotaModal(true);
                  } else {
                    setNuevaDerivacionForm(!nuevaDerivacionForm);
                  }
                }}
                disabled={anularCancelar || nota.estado === 10}
              >
                <Plus size="20" color={anularCancelar ? "grey" : " #f0292a"} />
              </CircleButton>
            </NavWrapper>

            <DataTable
              data={currentCandidatosList}
              title={
                <CardHeader className="py-3 px-0 d-flex align-items-center justify-content-between">
                  <div>
                    {derivacionesData && derivacionSelected && (
                      <KPIcard className="card mb-0 mr-2" style={{ height: "40px" }} borderRadius="4px">
                        <div className="card-body d-flex align-items-center justify-content-between mb-2 pb-0">
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <IconKpi svgWidth="20px" svgHeight="20px">
                              <FontAwesomeIcon icon={faUsers} />
                            </IconKpi>
                            <ContentKpi>
                              <h3>Cubiertos/ Totales</h3>
                              <div className="d-flex align-items-end justify-content-start">
                                {totalCandidatos ? (
                                  <>
                                    <p>{`${derivacionSelected.cubiertas || 0}/ ${derivacionSelected.candidatos || 0}`}</p>
                                  </>
                                ) : (
                                  <>
                                    <p>-</p>
                                  </>
                                )}
                              </div>
                            </ContentKpi>
                          </div>
                        </div>
                      </KPIcard>
                    )}
                  </div>
                  <div className="d-flex justify-content-center align-items-center pt-0 pb-0">
                    <KPIcard className="card mb-0 mr-2" style={{ height: "40px" }} borderRadius="4px">
                      <div className="card-body d-flex align-items-center justify-content-between mb-2 pb-0">
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                          <IconKpi svgWidth="20px" svgHeight="20px">
                            <FontAwesomeIcon icon={faFileCircleCheck} />
                          </IconKpi>
                          <ContentKpi>
                            <h3>Sin leer/ Totales</h3>
                            <div className="d-flex align-items-end justify-content-start">
                              {totalCandidatos ? (
                                <>
                                  <p>{`${candidatosSinLeer || 0}/ ${totalCandidatos || 0}`}</p>
                                </>
                              ) : (
                                <>
                                  <p>-</p>
                                </>
                              )}
                            </div>
                          </ContentKpi>
                        </div>
                      </div>
                    </KPIcard>

                    <ButtonSecondary
                      padding="10px 30px"
                      borderRadius="4px"
                      fontSize="14px"
                      type="button"
                      color={anularCancelar ? "link" : ""}
                      onClick={handleUploadFileButton}
                      disabled={anularCancelar}
                    >
                      Importar
                      <span className="m-1 ml-2">{anularCancelar ? <FilePlus size="20" color="grey" /> : <FilePlus size="20" />}</span>
                    </ButtonSecondary>

                    <ButtonSecondary
                      padding="10px 30px"
                      borderRadius="4px"
                      fontSize="14px"
                      className="d-flex align-items-center justify-content-center  mr-2"
                      type="button"
                      onClick={() => (window.location.href = "https://adecco-arg.s3.amazonaws.com/Template-carga-masiva-candidatos-v.2.xlsm")}
                      aria-label="template candidatos"
                      disabled={anularCancelar}
                      color={anularCancelar ? "link" : "success"}
                    >
                      Template
                      <span className="m-1 ml-2">{anularCancelar ? <Download size="20" color="grey" /> : <Download size="20" />}</span>
                    </ButtonSecondary>

                    <ButtonSecondary
                      padding="10px 30px"
                      borderRadius="4px"
                      type="button"
                      color={anularCancelar ? "link" : ""}
                      fontSize="14px"
                      onClick={() => setNuevoCandidatoForm(!nuevoCandidatoForm)}
                      disabled={anularCancelar}
                    >
                      Candidato
                      <span className="m-1 ml-2">{anularCancelar ? <Plus size="20" color="grey" /> : <Plus size="20" />}</span>
                    </ButtonSecondary>
                  </div>
                </CardHeader>
              }
              noDataComponent={
                <div className="p-3">
                  <b>No se encontraron candidatos</b>
                </div>
              }
              onRowClicked={(row) => handleEditCandidatoNpForm(row)}
              selectableRows
              contextComponent={contextComponent}
              onSelectedRowsChange={handleRowSelected}
              clearSelectedRows={toggleCleared}
              pagination
              paginationPerPage={5}
              paginationRowsPerPageOptions={[5, 10]}
              paginationComponentOptions={{ rowsPerPageText: "Candidatos por página", rangeSeparatorText: "de" }}
              customStyles={tableCustomStylesNP}
              striped
              highlightOnHover
              columns={[
                {
                  name: "Candidato",
                  selector: (row) => (
                    <>
                      <UncontrolledTooltip trigger="hover" target={`nombre${row.candidatoId}`}>
                        {`${row.candidato.nombre} ${row.candidato.apellido}`}
                      </UncontrolledTooltip>
                      <div data-tag="allowRowEvents" className="mx-2" id={`nombre${row.candidatoId}`}>{`${row.candidato.nombre} ${row.candidato.apellido}`}</div>
                    </>
                  ),

                  center: true,
                  compact: true,
                  sortable: true,
                  style: {
                    cursor: "pointer",
                  },
                },

                {
                  name: "Email",
                  selector: (row) => (
                    <>
                      <UncontrolledTooltip trigger="hover" target={`email${row.candidatoId}`}>
                        {row.candidato.email}
                      </UncontrolledTooltip>
                      <div data-tag="allowRowEvents" id={`email${row.candidatoId}`}>
                        {row.candidato.email}
                      </div>
                    </>
                  ),
                  center: true,
                  compact: true,
                  style: {
                    textAlign: "center",
                    cursor: "pointer",
                  },
                },
                {
                  name: "Teléfono",
                  selector: (row) => row.candidato.telefono,
                  center: true,
                  compact: true,
                  style: {
                    textAlign: "center",
                    cursor: "pointer",
                  },
                },
                {
                  name: "Portal",
                  selector: (row) => row.candidato.portal,
                  center: true,
                  compact: true,
                  // width: "90px",
                  style: {
                    textAlign: "center",
                    cursor: "pointer",
                  },
                },
                {
                  name: "Creación",
                  // al traer los candidatos por NP la relacion se llama RelsCandidatosNP,
                  // pero al traerlos por derivacionId se llama RelsCandidatosNPs
                  selector: (row) => moment(row.createdAt).format("DD/MM/YY"),
                  sortable: true,
                  center: true,
                  compact: true,
                  style: {
                    textAlign: "center",
                    cursor: "pointer",
                  },
                },
                {
                  name: "Estado",
                  selector: (row) =>
                    row.candidato && row.estado ? (
                      <>
                        {row.motivo && row.estado === 6 && (
                          <UncontrolledTooltip placement="top" target={`estado${row.candidatoId}`}>
                            {getMotivoNoAvanza(row.motivo, motivos, row.motivoOtro)}
                          </UncontrolledTooltip>
                        )}
                        <p data-tag="allowRowEvents" id={`estado${row.candidatoId}`}>
                          {getEstadoByValue(row.estado, categories && categories.estadoCandidatoNP && categories.estadoCandidatoNP.type)}
                        </p>
                      </>
                    ) : (
                      ""
                    ),
                  center: true,
                  // compact: true,
                  style: {
                    textAlign: "center",
                    cursor: "pointer",
                  },
                },
                {
                  name: "Acción",
                  selector: (row) => (
                    <div style={{ display: "flex", justifyContent: "space-around", flexWrap: "nowrap" }}>
                      {row && row.observaciones !== null && (
                        <>
                          <UncontrolledTooltip placement="top" target={`observaciones${row.candidatoId}`}>
                            Comentarios
                          </UncontrolledTooltip>
                          <Button
                            className="px-1"
                            size="xs"
                            color="link"
                            id={`observaciones${row.candidatoId}`}
                            onClick={() => {
                              setShowObservaciones(!showObservaciones);
                              setObservaciones(row.observaciones);
                            }}
                          >
                            <Info size="14" color="#293134" />
                          </Button>
                        </>
                      )}

                      <UncontrolledTooltip placement="top" target={`candidatoCV${row.candidatoId}`}>
                        Descargar CV
                      </UncontrolledTooltip>
                      <Button
                        className="px-1"
                        size="xs"
                        color="link"
                        id={`candidatoCV${row.candidatoId}`}
                        onClick={() => handleDownloadCV(row.candidato)}
                        disabled={anularCancelar || row.candidato.Files.length === 0}
                      >
                        <Paperclip size="14" color={anularCancelar || row.candidato.Files.length === 0 ? "#293134" : "#f0292a"} />
                      </Button>

                      <UncontrolledTooltip placement="top" target={`candidatoLeido${row.candidatoId}`}>
                        Marcar como leido
                      </UncontrolledTooltip>
                      <InputCheckboxContainer id={`candidatoLeido${row.candidatoId}`} checkboxHeight="18px" borderRadius="1px">
                        <div className="checkbox-wrapper-19">
                          <input
                            type="checkbox"
                            id={`leido${row.candidatoId}`}
                            name={`leido${row.candidatoId}`}
                            onChange={(e) => handleMarkAsRead(e, row)}
                            checked={row.lecturasCandidato && row.lecturasCandidato.length > 0 ? row.lecturasCandidato[0].readed : false}
                          />
                          <label htmlFor={`leido${row.candidatoId}`} className="check-box m-0" />
                        </div>
                      </InputCheckboxContainer>

                      {!!derivacionId && (
                        <>
                          <UncontrolledTooltip placement="top" target={`delete${row.candidatoId}`}>
                            Eliminar de la derivación
                          </UncontrolledTooltip>
                          <Button
                            className="px-1 ml-3"
                            size="xs"
                            color="link"
                            id={`delete${row.candidatoId}`}
                            onClick={() => handleDeleteCandidatoModal(row.candidato)}
                            disabled={anularCancelar}
                          >
                            <Trash2 size="14" color="#293134" />
                          </Button>
                        </>
                      )}
                    </div>
                  ),
                  center: true,
                  compact: true,
                },
              ]}
            />
          </CardBody>
        </Card>
      </BlurSpinner>
      {showObservaciones && <ObservacionesModal toggle={() => setShowObservaciones(!showObservaciones)} isOpen={showObservaciones} observaciones={observaciones} />}
    </>
  );
};

export default CandidatosNP;
